
import { useCalendarStore } from 'src/store/calendar';
import { utils } from 'src/utils';


export function useCalendar() {
	const store = useCalendarStore();

	const matriculationOathCalendar = store.state.matriculationOathCalendar;
	const massSpecialResitCalendar = store.state.massSpecialResitCalendar;
	const finalYearSpecialResitCalendar = store.state.finalYearSpecialResitCalendar;


  // Format as YYYY-MM-DD
  const formattedDate = new Date().toISOString().split("T")[0];

  let showMathriculationOath = false
  let showmassSpecialResit = false
  let showfinalYearSpecialResit = false
  



	setCalendarData();

	function setCalendarData() {
		if (matriculationOathCalendar && matriculationOathCalendar?.start_date && matriculationOathCalendar?.end_date) {
      const startDate = new Date(matriculationOathCalendar.start_date);
      const endDate = new Date(matriculationOathCalendar.end_date);
      const todayDate = new Date(formattedDate);
      if (startDate <= todayDate && endDate >= todayDate) {
        showMathriculationOath = true;
      }
		}
    if (massSpecialResitCalendar && massSpecialResitCalendar?.start_date && massSpecialResitCalendar?.end_date) {
      const startDate = new Date(massSpecialResitCalendar.start_date);
      const endDate = new Date(massSpecialResitCalendar.end_date);
      const todayDate = new Date(formattedDate);
      if (startDate <= todayDate && endDate >= todayDate) {
        showmassSpecialResit = true;
      }
		}
    if (finalYearSpecialResitCalendar && finalYearSpecialResitCalendar?.start_date && finalYearSpecialResitCalendar?.end_date) {
      const startDate = new Date(finalYearSpecialResitCalendar.start_date);
      const endDate = new Date(finalYearSpecialResitCalendar.end_date);
      const todayDate = new Date(formattedDate);
      if (startDate <= todayDate && endDate >= todayDate) {
        showfinalYearSpecialResit = true;
      }
		}
	}

  async function getCalendarData() {
		
			try {
				//fetch user data for the first time and saves in the store
				await store.getMathriculationOathCalendar();
				await store.getMassSpecialResitCalendar();
				await store.getFinalYearSpecialResitCalendar();
			}
			catch (e) {
				console.log(e) //token must have expired
			}
		
		return {
			matriculationOathCalendar: store.state.matriculationOathCalendar,
			massSpecialResitCalendar: store.state.massSpecialResitCalendar,
			finalYearSpecialResitCalendar: store.state.finalYearSpecialResitCalendar,
		};
	}

	
	return {
		store,
		getCalendarData,
    showMathriculationOath,
    showmassSpecialResit,
    showfinalYearSpecialResit,
	}
}
